module.exports = __webpack_public_path__ + "img/banner.d0199e4d.jpg";